var map = {
	"./air-conditioner.svg": 1515,
	"./airplane.svg": 1516,
	"./airport.svg": 1517,
	"./approved.svg": 1518,
	"./aquapark.svg": 1519,
	"./arrow-answer-bubble.svg": 1520,
	"./arrow-back.svg": 1521,
	"./arrow-flight.svg": 1522,
	"./arrow-right-top.svg": 1523,
	"./arrow-right.svg": 1524,
	"./bar.svg": 1525,
	"./beach-surface-pebble.svg": 1526,
	"./beach-surface-platform.svg": 1527,
	"./beach-surface-sand-pebble.svg": 1528,
	"./beach-surface-sand.svg": 1529,
	"./beachsurface.svg": 1530,
	"./card.svg": 1531,
	"./check.svg": 1532,
	"./clock.svg": 1533,
	"./cvv.svg": 1534,
	"./double-arrow.svg": 1535,
	"./empty-hotel-map.svg": 1536,
	"./filters/clear-filters.svg": 1537,
	"./filters/filter-button.svg": 1538,
	"./filters/instant-confirm-colored.svg": 1539,
	"./filters/instant-confirm.svg": 1540,
	"./filters/search-distance.svg": 1541,
	"./filters/search-lift.svg": 1542,
	"./fire.svg": 1543,
	"./flight-direct-mobile.svg": 1544,
	"./flight-direct.svg": 1545,
	"./flight-direct__additional-mobile.svg": 1546,
	"./flight-direct__additional.svg": 1547,
	"./flight-transition-mobile.svg": 1548,
	"./flight-transition.svg": 1549,
	"./flight-transition__additional-mobile.svg": 1550,
	"./flight-transition__additional.svg": 1551,
	"./food.svg": 1552,
	"./free-cancellation-colored.svg": 1553,
	"./fuel-green.svg": 1554,
	"./fuel-white.svg": 1555,
	"./funicular.svg": 1556,
	"./gallery-empty.svg": 1557,
	"./garranty.svg": 1558,
	"./gender-female.svg": 1559,
	"./gender-male.svg": 1560,
	"./gender-unidentified.svg": 1561,
	"./gift.svg": 1562,
	"./glass.svg": 1563,
	"./gym.svg": 1564,
	"./hand-luggage.svg": 1565,
	"./heated-pool.svg": 1566,
	"./hold-luggage.svg": 1567,
	"./hotel-reply.svg": 1568,
	"./included-services.svg": 1569,
	"./included.svg": 1570,
	"./kids-club.svg": 1571,
	"./kids-menu.svg": 1572,
	"./kids-pool.svg": 1573,
	"./lightning.svg": 1574,
	"./lock.svg": 1575,
	"./logo.svg": 1576,
	"./lt-extra/bonus_insurance.svg": 1577,
	"./lt-extra/bonus_ivi.svg": 1578,
	"./luggage-wrapping.svg": 1579,
	"./man.svg": 1580,
	"./map-button.svg": 1581,
	"./map/collapse-arrows.svg": 1582,
	"./map/expand-arrows.svg": 1583,
	"./massage.svg": 1584,
	"./nanny.svg": 1585,
	"./only-lt-half.svg": 1586,
	"./parking.svg": 1587,
	"./payment-mir.svg": 1588,
	"./paymenttype.svg": 1589,
	"./plane-arrival.svg": 1590,
	"./plane.svg": 1591,
	"./private-beach.svg": 1592,
	"./rest_types/active.svg": 1593,
	"./rest_types/couples.svg": 1594,
	"./rest_types/family.svg": 1595,
	"./review-tab-selected.svg": 1596,
	"./sauna.svg": 1597,
	"./search-sorting.svg": 1598,
	"./searcher-empty-request.svg": 1599,
	"./searcher-filtered-empty.svg": 1600,
	"./sidebar-bottom-triangle.svg": 1601,
	"./sidebar-menu-active.svg": 1602,
	"./sign_additional.svg": 1603,
	"./ski-in-ski-out.svg": 1604,
	"./social-fb.svg": 1605,
	"./social-share.svg": 1606,
	"./social-vk.svg": 1607,
	"./special.svg": 1608,
	"./success_additional.svg": 1609,
	"./swimming-pool.svg": 1610,
	"./thumbs-up.svg": 1611,
	"./wave.svg": 1612,
	"./wifi.svg": 1613
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1004;